import { AuthenticationContainer } from 'entities/Authentication';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Typography } from 'shared/_ui';
import { SuccessIcon } from './SuccessIcon';
import styles from './styles.module.scss';
import { useNavigate } from "react-router-dom";

interface SuccessPageProps {
    returnLink? : string;
}

function isTelegramWebApp() {
  // eslint-disable-next-line
  // @ts-ignore
  return typeof TelegramWebviewProxy !== 'undefined';
}

export const SuccessfulPaymentPage : React.FC<SuccessPageProps> = ({returnLink}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const page_content = 
  <Flex className={styles.wrapper} direction="column" align="center">
    <SuccessIcon className={styles.icon} />
    <Typography.Title className={styles.heading} level={1}>
      {t('banner.successfulPayment.heading')}
    </Typography.Title>
  </Flex>;

  const web_page = 
  <AuthenticationContainer 
    footer = {
      <Button type='primary' onClick={()=>{navigate(returnLink!)}}>
          {t('banner.successfulPayment.button')}
      </Button>
  }>
  {page_content}
</AuthenticationContainer>

  const frame_page = <div className={styles.framewrapper}>{page_content}</div>

  return (returnLink && !isTelegramWebApp()) ? web_page : frame_page;
};